// Pipeline Mock Data and Stage Configurations

export const PIPELINE_STAGES = [
  { code: "QUALIFICATION", label: "Qualification", color: "#6366f1" },
  { code: "NEEDS_ANALYSIS", label: "Needs Analysis", color: "#3b82f6" },
  { code: "VALUE_PROPOSITION", label: "Value Proposition", color: "#0ea5e9" },
  { code: "PROPOSAL_QUOTE", label: "Proposal / Price Quote", color: "#8b5cf6" },
  { code: "NEGOTIATION_REVIEW", label: "Negotiation / Review", color: "#f59e0b" },
  { code: "CLOSED_WON", label: "Closed Won", color: "#10b981" },
  { code: "CLOSED_LOST", label: "Closed Lost", color: "#ef4444" },
];

export const INITIAL_DEALS = [
  {
    _id: "deal-101",
    leadId: "lead-1",
    leadCompanyName: "Nexus Tech Solutions",
    contactName: "Aarav Sharma",
    contactNumber: "+91 98450 12345",
    assignedEmployeeName: "Rahul Sharma",
    dealName: "Enterprise Telephony 50 Reps",
    amount: 150000,
    closingDate: "2026-09-15",
    priority: "High",
    pipelineStage: "QUALIFICATION",
    stageChangedAt: "2026-08-20T10:00:00Z",
    description: "Looking to replace existing legacy PBX with cloud call recording for 50 sales agents.",
  },
  {
    _id: "deal-102",
    leadId: "lead-2",
    leadCompanyName: "Apex Global Logistics",
    contactName: "Vikram Malhotra",
    contactNumber: "+91 98200 45678",
    assignedEmployeeName: "Pooja Hegde",
    dealName: "Fleet Mobile Call Sync",
    amount: 320000,
    closingDate: "2026-09-30",
    priority: "High",
    pipelineStage: "NEEDS_ANALYSIS",
    stageChangedAt: "2026-08-18T14:30:00Z",
    customerNeed: "Track 1,200 driver phone calls and sync delivery confirmation logs automatically.",
    painPoint: "High call disputes regarding delivery drop-off times.",
  },
  {
    _id: "deal-103",
    leadId: "lead-3",
    leadCompanyName: "Horizon Healthcare",
    contactName: "Dr. Rajesh Varma",
    contactNumber: "+91 97000 23456",
    assignedEmployeeName: "Amit Verma",
    dealName: "Patient Follow-up Telephony Suite",
    amount: 180000,
    closingDate: "2026-09-10",
    priority: "Medium",
    pipelineStage: "VALUE_PROPOSITION",
    stageChangedAt: "2026-08-22T09:15:00Z",
    proposedSolution: "Automated outbound clinic reminders with bi-directional CRM timeline logging.",
    keyBenefits: "Reduce no-show rates by 40% and streamline appointment rescheduling.",
  },
  {
    _id: "deal-104",
    leadId: "lead-4",
    leadCompanyName: "Zenith Retail Ventures",
    contactName: "Ananya Roy",
    contactNumber: "+91 99100 87654",
    assignedEmployeeName: "Rahul Sharma",
    dealName: "Omnichannel Storefront Voice Integration",
    amount: 240000,
    closingDate: "2026-09-05",
    priority: "High",
    pipelineStage: "PROPOSAL_QUOTE",
    stageChangedAt: "2026-08-24T16:00:00Z",
    quoteAmount: 240000,
    proposalSentDate: "2026-08-24",
  },
  {
    _id: "deal-105",
    leadId: "lead-5",
    leadCompanyName: "Starlight FinServ",
    contactName: "Rohan Krishnan",
    contactNumber: "+91 94440 98765",
    assignedEmployeeName: "Amit Verma",
    dealName: "SOC2 Compliance Voice Archival",
    amount: 450000,
    closingDate: "2026-08-31",
    priority: "Medium",
    pipelineStage: "NEGOTIATION_REVIEW",
    stageChangedAt: "2026-08-15T11:00:00Z",
    dealCloseAmount: 420000,
    advancePaid: "YES",
    negotiationNotes: "Client requested 5% discount for 2-year annual upfront commitment.",
  },
  {
    _id: "deal-106",
    leadId: "lead-6",
    leadCompanyName: "Kavya Tech Labs",
    contactName: "Sanjay Gupta",
    contactNumber: "+91 98888 11223",
    assignedEmployeeName: "Pooja Hegde",
    dealName: "Mobile Call CRM Tier 1",
    amount: 110000,
    closingDate: "2026-08-10",
    priority: "Low",
    pipelineStage: "CLOSED_WON",
    stageChangedAt: "2026-08-10T12:00:00Z",
    finalAmount: 110000,
    wonNotes: "Client signed after successful 14-day field pilot.",
  },
  {
    _id: "deal-107",
    leadId: "lead-7",
    leadCompanyName: "Metro Properties",
    contactName: "Vikram Singh",
    contactNumber: "+91 97777 44332",
    assignedEmployeeName: "Amit Verma",
    dealName: "Real Estate Voice Broadcast",
    amount: 95000,
    closingDate: "2026-08-12",
    priority: "Low",
    pipelineStage: "CLOSED_LOST",
    stageChangedAt: "2026-08-12T15:00:00Z",
    lostReason: "PRICE",
    lossNotes: "Went with free open-source alternative.",
  },
];

export function daysInStage(stageChangedAt) {
  if (!stageChangedAt) return 0;
  const ms = Date.now() - new Date(stageChangedAt).getTime();
  return Math.max(0, Math.floor(ms / (1000 * 60 * 60 * 24)));
}
